import { getNameSuggestions } from '~/api/dadata';
import { InputBase } from '~/InputBase';
import { withAutocomplete } from './withAutocomplete';

/** @typedef {import('~/api/dadata').NameSuggestion} NameSuggestion */

/**
 *
 * @param {NameSuggestion} param0
 * @returns
 */
function getFullName({ name, surname, patronymic }) {
	const fullname = [];

	if (surname)
		fullname.push(surname);

	if (name)
		fullname.push(name);

	if (patronymic)
		fullname.push(patronymic);

	return fullname.join(' ');
}

/** @type {import('~/Autocomplete').AutocompleteDataset<NameSuggestion>} */
const dataset = {
	source: (query, cb) => {
		getNameSuggestions(query)
			.then(cb)
			.catch(error => {
				console.error(error);
				cb([]);
			});
	},
	displayKey: ({ data }) => getFullName(data),
	templates: {
		suggestion: ({ data }) => getFullName(data),
	},
	debounce: 250,
}

export const InputNameAutocomplete = {
	name: 'InputNameAutocomplete',
	extends: InputBase,
	mixins: [
		withAutocomplete([dataset]),
	],
}
